module.exports = __webpack_public_path__ + "static/back-b4bf6cb961a3bf3cbbb372249debad72.svg";